<template>
  <section class="py-12 secondary lighten-2">
    <v-container class="pa-0 pa-sm-3 pb-12 pb-sm-3">
      <v-img :src="item.image || ''" :alt="item.title" :position="$breakpoint.is.smAndDown ? 'top right' : 'center center'" contain>
        <v-row justify="center" align="center" class="fill-height my-5 my-sm-0" no-gutters>
          <v-col cols="12" sm="6" lg="5">
            <v-row>
              <v-col tag="h3">
                {{ item.title }}<br>
                {{ item.subtitle }}<br>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="bg-content">
                <span v-html="item.description"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="subtitle-1 accent--text">
                Geschikt voor:
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-6">
                <v-chip v-for="prepMethod in item.prep_methods" :key="prepMethod.title" color="primary" class="mr-2" small @click="$vuetify.goTo(`#${prepMethod.permalink}`, {offset: 100})">
                  {{ prepMethod.title }}
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-img>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
  },
};
</script>

<style lang="sass" scoped>
  .bg-content
    background: var(--v-secondary-lighten2)
    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      background: transparent
</style>
